import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import {Container} from 'reactstrap';
import './App.css';
import MainNavbar from './Navbar';
import Home from './Home';
import Team from './Team';
import Contact from './Contact';
import Logo from './images/logo.png';

export default function App() {
  return (
    <Router>
      <MainNavbar />
      <Container>
        <img alt="New Beginnings Logo" src={Logo} className="centered-image" />
        <div>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/team">
              <Team />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
          </Switch>
        </div>
      </Container>
    </Router>
  );
}